import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Image, XSquare } from 'react-feather';
import './css/imageDnD.css';
import messages from '../../../helpers/messages';

export class ImageDnD extends Component {
    constructor(props) {
        super(props);

        this.onDrop = this.onDrop.bind(this);
        this.onClear = this.onClear.bind(this);
    }

    onDrop(file) {
        if (file) {
            if (this.props.maxGifSize && file.name.toLowerCase().endsWith('.gif') && file.size > this.props.maxGifSize) {
                // handle gif rejection based on size:
                const rejectionReason = messages.errors.fileSizeExceeded(this.props.maxGifSize / 1000);
                this.props.onRejectedFile(rejectionReason);
            } else {
                this.props.onDrop(file);
            }
        }
    }

    onClear(ev) {
        ev.stopPropagation();
        this.props.onClear();
    }

    render() {
        const { className, onRejectedFile, showClearButton, image } = this.props;
        return (
            <Dropzone
                className={`${className} imageDnD uitest-dropzone`}
                multiple={false}
                accept="image/*"
                onDrop={acceptedFiles => this.onDrop(acceptedFiles[0])}
                onDropRejected={() => onRejectedFile(messages.errors.wrongType)}
            >
                {showClearButton && image && (
                    <button type="button" className="btn transparent clearButton uitest-clearbutton" onClick={this.onClear}>
                        <XSquare className="icon" />
                    </button>
                )}
                <div>
                    <Image className="icon" />
                    DROP IMAGE FILE <br /> OR
                    <button type="button">BROWSE</button>
                </div>
                {image && <img src={image} alt="" />}
            </Dropzone>
        );
    }
}

ImageDnD.propTypes = {
    /* @prop {func} onDrop passed from parent; handles parent state changes on accepting user input */
    onDrop: PropTypes.func.isRequired,
    /* @prop {func} onRejectedFile passed from parent; handles parent state changes on rejecting user input */
    onRejectedFile: PropTypes.func.isRequired,
    /* @prop {func} onClear passed from parent; handles parent state changes on clearing the data */
    onClear: PropTypes.func,
    /**@prop { string } image either an image-url or base64- encoded image-data to render */
    image: PropTypes.string,
    /**@prop { string } className custom css. Enables dynamic styling of the dropzone from parent components */
    className: PropTypes.string,
    /**@prop { bool } showClearButton displays a clear button to flush image-file selection. Defaults to false */
    showClearButton: PropTypes.bool,
    /**@prop { Number } maxGifSize maximum gif file size in bytes. Defaults to unlimited */
    maxGifSize: PropTypes.number
};

export default ImageDnD;
